import { uniqueByKey } from "kinnect-helpers";
import {
	Address,
	Customer,
	Model,
	PurchaseOrder,
	SalesOrder,
	Salesman,
	User,
	YardScheduleType,
	YardTrip
} from ".";

export default class Schedule extends Model {
	get singularNoun() {
		return "schedule";
	}

	get mutations() {
		return {
			address: Address,
			customer: Customer,
			purchaseOrders: PurchaseOrder,
			salesOrders: SalesOrder,
			salesman: Salesman,
			scheduleTypes: YardScheduleType,
			trip: YardTrip,
			user: User
		};
	}

	get createdTimestamp() {
		return ( new Date( this.created_at ) ).getTime();
	}

	get purchaseOrderErrors() {
		if ( this.purchaseOrders ) {
			const errors = this.purchaseOrders.reduce(
				( total, current ) => total.concat( current.errors || [] ),
				[]
			);

			return uniqueByKey( errors, "id" );
		}
	}

	get purchaseOrderNumbers() {
		if ( this.purchaseOrders ) {
			return this.purchaseOrders.map( po => po.purchaseOrderNumber ).join( ", " );
		}
	}

	get salesOrderErrors() {
		if ( this.salesOrders ) {
			const errors = this.salesOrders.reduce(
				( total, current ) => total.concat( current.errors || [] ),
				[]
			);

			return uniqueByKey( errors, "id" );
		}
	}

	get salesOrderNumbers() {
		if ( this.salesOrders ) {
			return this.salesOrders.map( so => so.salesOrderNumber ).join( ", " );
		}
	}

	get scheduleTypeNames() {
		if ( this.scheduleTypes ) {
			return this.scheduleTypes.map( st => st.name )
			.sort()
			.join( ", " );
		}
	}

	resource() {
		return "yard/schedules";
	}
}
